var React = require('react');

function Attachment (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"attachment"),React.createElement("path",{"d":"M249.080 103.78v262.92c0 57.316-46.464 103.78-103.78 103.78s-103.78-46.464-103.78-103.78v0-262.92c0-34.391 27.879-62.27 62.27-62.27s62.27 27.879 62.27 62.27v262.92c0 11.466-9.294 20.76-20.76 20.76s-20.76-9.294-20.76-20.76v0-262.92h-41.51v262.92c0 34.391 27.879 62.27 62.27 62.27s62.27-27.879 62.27-62.27v-262.92c-0.576-56.882-46.822-102.771-103.785-102.771s-103.209 45.889-103.784 102.716l-0.001 0.055v262.92c0 80.12 65.18 145.3 145.3 145.3s145.3-65.18 145.3-145.3v-262.92z","key":1})]);
}

Attachment.defaultProps = {"version":"1.1","width":"291","height":"512","viewBox":"0 0 291 512"};

module.exports = Attachment;

Attachment.default = Attachment;
